import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { LINKEDIN_CAMPAIGN_TYPE, META_OPTIMIZATION_GOAL_TYPE } from './SocialMediaConstant';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, ADS_TYPE } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { toast } from 'react-toastify';
import MetaAdsetForm from './Meta/MetaAdsetForm';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import * as API from '../../framework/API/api';
import { useTranslation } from '../../locale/useTranslation';
import SMAudienceEditForm from './SMAudienceEditForm';
import SMAdEditForm from './SMAdEditForm';
import BossDialog from '../../components/BossDialog';
import GoogleAdsetForm from './Google/GoogleAdsetForm';
import LinkedInAdsetForm from './LinkedIn/LinkedInAdsetForm';
import AdCreativeDetailsForm from './AdCreativeDetailsForm';
import YoutubeAdsetForm from './Youtube/YoutubeAdsetForm';

const SMAdsetForm = ({ onCancel, onSave, channel = {}, item = {}, campaign = {} }) => {

  const lang = useTranslation();

  const getFinalValue = (value) => {
    switch (channel?.adType) {
      case ADS_TYPE.META:
        return {
          conversion_location: value?.meta?.conversion_location ? { _id: value?.meta?.conversion_location, description: value?.meta?.conversion_location } : {},
          billing_event: value?.meta?.billing_event ? { _id: value?.meta?.billing_event, description: value?.meta?.billing_event } : {},
          optimization_goal: value?.meta?.optimization_goal ? { _id: value?.meta?.optimization_goal, description: value?.meta?.optimization_goal } : {},
          page_id: value?.meta?.page_id ?? "1141730029202037",
          application_id: value?.meta?.application_id ?? "",
          object_store_url: value?.meta?.object_store_url ?? "",
          pixel_id: value?.meta?.pixel_id ?? "123456789012345",
          custom_event_type: value?.meta?.custom_event_type ? { _id: value?.meta?.custom_event_type, description: value?.meta?.custom_event_type } : {},
          link: value?.meta?.link ?? "",
          button_type: value?.meta?.button_type ? { _id: value?.meta?.button_type, description: value?.meta?.button_type } : {},
          button_type_link: value?.meta?.button_type_link ?? "",
          message: value?.meta?.message ?? "",
        }
      case ADS_TYPE.GOOGLE:
        return {
          description: value?.google?.description ?? "",
          headline_part1: value?.google?.headline_part1 ?? "",
          headline_part2: value?.google?.headline_part2 ?? "",
          sitelinks: value?.google?.sitelinks ? value?.google?.sitelinks?.join(',') : "",
          finalUrl: value?.google?.finalUrl ?? "",
        }
      case ADS_TYPE.LINKEDIN:
        return {
          text: value?.linkedin?.text ?? "", // LINKEDIN_CAMPAIGN_TYPE.TEXT_AD
          landingPageUrl: value?.linkedin?.landingPageUrl ?? "", // LINKEDIN_CAMPAIGN_TYPE.TEXT_AD
          reference: value?.linkedin?.reference ?? "",

        }
      case ADS_TYPE.YOUTUBE:
        return {
          actionButtonLabel: value?.youtube?.actionButtonLabel ?? "",
          actionHeadline: value?.youtube?.actionHeadline ?? "",
          finalUrls: value?.youtube?.finalUrls ? value?.youtube?.finalUrls?.join(',') : "",
        }
    }
  }

  let blankDataItem = {
    ...item,
    audience: item?.audience ?? {},
    start_time: item?.start_time ? moment(item?.start_time).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss'),
    end_time: item?.end_time ? moment(item?.end_time).format('YYYY-MM-DD HH:mm:ss') : moment().add(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    ...getFinalValue(item),
    ad: item?.ad ?? {},
  }
  const [dataItem, setDataItem] = useState(blankDataItem);
  const [isMobile, setIsMobile] = useState(false);
  const [showAdPopup, setShowAdPopup] = useState(false);
  const [showCreateAdPopup, setShowCreateAdPopup] = useState(false);
  const [audience, setAudience] = useState([])
  const defaultFormState = {
    Audience: false,
  }
  const [showEditForm, setShowEditForm] = useState(defaultFormState);

  useEffect(() => {
    const updateScreenType = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      setIsMobile(isPortrait);
    };
    updateScreenType();
    window.addEventListener('resize', updateScreenType);
    return () => window.removeEventListener('resize', updateScreenType);
  }, []);

  useEffect(() => {
    loadCombo();
  }, []);

  const loadCombo = async () => {
    let audienceRes = await API.getDataLookup(ENTITYNAME.SM_Audience, { query: ["channel.adType", "=", channel?.adType] });
    setAudience(audienceRes.data);
    if (!dataItem?.audience?._id) setDataItem({ ...dataItem, audience: utility.getDefaultItem(audienceRes.data) })
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    setDataItem({ ...dataItem, [name]: value });
  };

  const isValid = () => {
    // if (!dataItem?.audience || Object.keys(dataItem?.audience).length === 0) {
    //   toast.error('Please select audience', { position: toast.POSITION.TOP_RIGHT });
    //   return false;
    // }
    if (!dataItem?.start_time || dataItem?.start_time === "") {
      toast.error('Please select start time', { position: toast.POSITION.TOP_RIGHT });
      return false;
    }
    if (!dataItem?.end_time || dataItem?.end_time === "") {
      toast.error('Please select end time', { position: toast.POSITION.TOP_RIGHT });
      return false;
    }
    if (dataItem.end_time < dataItem.start_time) {
      toast.error(lang.end_time_cannot_be_earlier_than_start_time_message, {
        position: toast.POSITION.TOP_RIGHT
      })
      return false
    }
    
    switch (channel?.adType) {
      case ADS_TYPE.META:
        if (!dataItem?.conversion_location || Object.keys(dataItem?.conversion_location).length === 0) {
          toast.error('Please select conversion location', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.billing_event || Object.keys(dataItem?.billing_event).length === 0) {
          toast.error('Please select billing event', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.optimization_goal || Object.keys(dataItem?.optimization_goal).length === 0) {
          toast.error('Please select optimization goal', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.ad || Object.keys(dataItem?.ad).length === 0) {
          toast.error('Please select ad', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.page || Object.keys(dataItem?.page).length === 0) {
          toast.error('Please select page', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (dataItem?.optimization_goal?._id === META_OPTIMIZATION_GOAL_TYPE.CONVERSIONS) {
          if (!dataItem?.custom_event_type || Object.keys(dataItem?.custom_event_type).length === 0) {
            toast.error('Please select custom event type', { position: toast.POSITION.TOP_RIGHT });
            return false;
          }
          if (!dataItem?.pixel_id || dataItem?.pixel_id === "") {
            toast.error('Please enter pixel id', { position: toast.POSITION.TOP_RIGHT });
            return false;
          }
        }
        if (dataItem?.optimization_goal?._id === META_OPTIMIZATION_GOAL_TYPE.APP_INSTALLS && (!dataItem?.application_id || dataItem?.application_id === "")) {
          toast.error('Please enter application id', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.link || dataItem?.link === "") {
          toast.error('Please enter link', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.button_type || Object.keys(dataItem?.button_type).length === 0) {
          toast.error('Please select button type', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.message || dataItem?.message === "") {
          toast.error('Please enter message', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        break;
      case ADS_TYPE.GOOGLE:
        if (!dataItem?.description || dataItem?.description === "") {
          toast.error('Please enter description', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.headline_part1 || dataItem?.headline_part1 === "") {
          toast.error('Please enter headline part1', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.headline_part2 || dataItem?.headline_part2 === "") {
          toast.error('Please enter headline part2', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        break;
      case ADS_TYPE.LINKEDIN:
        if (campaign?.type?.description !== LINKEDIN_CAMPAIGN_TYPE.TEXT_AD && (!dataItem?.ad || Object.keys(dataItem?.ad).length === 0)) {
          toast.error('Please select ad', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.text || dataItem?.text === "") {
          toast.error('Please enter text', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        if (!dataItem?.landingPageUrl || dataItem?.landingPageUrl === "") {
          toast.error('Please enter landing page url', { position: toast.POSITION.TOP_RIGHT });
          return false;
        }
        break;
    }
    return true
  }

  const getOptimizationGoal = (value) => {
    switch (value?.optimization_goal?._id) {
      case META_OPTIMIZATION_GOAL_TYPE.APP_INSTALLS:
        return { application_id: value?.application_id ?? "", object_store_url: value?.object_store_url ?? "", };
      case META_OPTIMIZATION_GOAL_TYPE.CONVERSIONS:
        return {
          pixel_id: value?.pixel_id ?? "",
          custom_event_type: value?.custom_event_type && Object.keys(value?.custom_event_type).length > 0 ? value?.custom_event_type?.description : {},
        };
    }
  }

  const saveFinalValue = (value) => {
    switch (channel?.adType) {
      case ADS_TYPE.META:
        return {
          meta: {
            conversion_location: value?.conversion_location && Object.keys(value?.conversion_location).length > 0 ? value?.conversion_location?.description : null,
            billing_event: value?.billing_event && Object.keys(value?.billing_event).length > 0 ? value?.billing_event?.description : null,
            optimization_goal: value?.optimization_goal?.description,
            ...getOptimizationGoal(value),
            link: value?.link ?? "",
            button_type: value?.button_type && Object.keys(value?.button_type).length > 0 ? value?.button_type?.description : null,
            button_type_link: value?.button_type_link ?? "",
            message: value?.message ?? "",
            page_id: value?.page?.id ?? ""
          }
        }
      case ADS_TYPE.GOOGLE:
        return {
          google: {
            description: value?.description ?? "",
            headline_part1: value?.headline_part1 ?? "",
            headline_part2: value?.headline_part2 ?? "",
            finalUrl: value?.finalUrl ?? "",
            sitelinks: dataItem.sitelinks ? dataItem.sitelinks.split(',').map(s => s.trim()).filter(Boolean) : []
          }
        }
      case ADS_TYPE.LINKEDIN:
        return {
          linkedin: {
            text: value?.text ?? "",
            landingPageUrl: value?.landingPageUrl ?? "",
            reference: value?.reference ?? "",
          }
        }
      case ADS_TYPE.YOUTUBE:
        return {
          youtube: {
            actionButtonLabel: value?.actionButtonLabel ?? "",
            actionHeadline: value?.actionHeadline ?? "",
            finalUrls: value?.finalUrls ? value?.finalUrls?.split(',').map(s => s.trim()).filter(Boolean) : [],
          }
        }
    }
  }

  const handleSubmit = async (e) => {
    if (!isValid()) return;

    let finalData = {
      _id: dataItem?._id,
      SID: dataItem?.SID,
      index: dataItem?.index,
      audience: dataItem?.audience && Object.keys(dataItem?.audience).length > 0 ? { _id: dataItem?.audience?._id, name: dataItem?.audience?.name } : {},
      start_time: dataItem?.start_time ? utility.convertStringDatetoMilliseconds(dataItem?.start_time) : "",
      end_time: dataItem?.end_time ? utility.convertStringDatetoMilliseconds(dataItem?.end_time) : "",
      ...saveFinalValue(dataItem),
      ad: dataItem?.ad ?? {}
    }
    console.log(finalData);

    onSave(finalData);
    onCancel();
  }

  const handleAdSelected = (item) => {
    setDataItem({ ...dataItem, ad: item?.length > 0 ? item[0] : {} });
  }

  const onCreateMasterClick = (key) => {
    setShowEditForm({
      ...defaultFormState,
      [key]: true
    });
  }

  const onAudienceSave = (item) => {
    setDataItem({ ...dataItem, audience: item });
  }

  const saveDataAdPopup = (item) => {
    setDataItem({ ...dataItem, ad: item });
  }

  return (
    <div>
      <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onCancel} />
      <div className='row'>
        <div className='col-3'>
          <label htmlFor="audience" >Audience *</label>
          <DropDownList
            name="audience"
            textField="name"
            dataItemKey="_id"
            data={audience}
            value={dataItem.audience}
            onChange={onChange}
          />
        </div>
        <div className="col-1" style={{ padding: '0px' }}>
          <button type="button" title={lang.create_audience_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
            style={{ height: "30px", margin: '20px 0px 0px 0px' }} onClick={() => { onCreateMasterClick('Audience') }}><i className="fa-solid fa-plus fa-xs"></i>
          </button>
        </div>
        <div className='col-4'>
          <label htmlFor="start_time" >Start Time *</label>
          <input
            type="datetime-local"
            id="start_time"
            name="start_time"
            value={dataItem.start_time}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
        <div className='col-4'>
          <label htmlFor="end_time" >End Time *</label>
          <input
            type="datetime-local"
            id="end_time"
            name="end_time"
            value={dataItem.end_time}
            onChange={onChange}
            className="form-control form-control-sm"
          />
        </div>
      </div>
      {(
        channel?.adType !== ADS_TYPE.GOOGLE &&
        campaign?.type?.description != LINKEDIN_CAMPAIGN_TYPE.TEXT_AD
      ) && (
          <div className='mt-2'>
            <label htmlFor="ad">Ad *</label>
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                name="ad"
                placeholder="Select Ad"
                value={dataItem?.ad?.title || ""}
                className="form-control form-control-sm"
                readOnly
              />
              <div className="d-flex gap-2 ms-auto">
                <RoundButton btnColor="success" iconColor="white" title="Add" onClick={() => setShowAdPopup(true)} icon="plus" />
                <RoundButton btnColor="danger" iconColor="white" title="Remove" onClick={() => setDataItem({ ...dataItem, ad: {} })} icon="trash" />
                <RoundButton btnColor="primary" iconColor="white" title="Create" onClick={() => setShowCreateAdPopup(true)} icon="file-alt" />
              </div>
            </div>
          </div>
        )}
      {/* Showing details ad*/}
      {dataItem?.ad && Object.keys(dataItem?.ad)?.length > 0 && <AdCreativeDetailsForm ad={dataItem?.ad} />}
      
      {/* Showing fields based on channel */}
      <div className='text-sm text-gray-500 font-bold mt-2'>{channel?.adType ? utility.getKeyByValue(ADS_TYPE, channel?.adType) : ""}</div>
      <div className="col-span-3 border border-gray-200 shadow-md shadow-gray-200 rounded-lg bg-white p-2">
        {channel?.adType === ADS_TYPE.META && <MetaAdsetForm objective={campaign?.objective} dataItem={dataItem} setDataItem={setDataItem} onChange={onChange} />}
        {channel?.adType === ADS_TYPE.GOOGLE && <GoogleAdsetForm dataItem={dataItem} onChange={onChange} />}
        {channel?.adType === ADS_TYPE.LINKEDIN && <LinkedInAdsetForm type={campaign?.type?.description} dataItem={dataItem} onChange={onChange} />}
        {channel?.adType === ADS_TYPE.YOUTUBE && <YoutubeAdsetForm dataItem={dataItem} onChange={onChange} />}
      </div>

      {showAdPopup && <CollectionSelection wherestatement={channel?.adType === ADS_TYPE.YOUTUBE ? ["creatives.format", "=", "mp4"] : ["creatives.format", "!=", "mp4"]} entityname={ENTITYNAME.SM_Ads} title="Select Ads" addButtonTitles="Add" width={isMobile ? "95%" : "80%"} closeForm={() => setShowAdPopup(false)} mode={"single"} setDataList={handleAdSelected} />}
      {showEditForm.Audience && <SMAudienceEditForm cancelEdit={() => { setShowEditForm({ ...showEditForm, Audience: false }); loadCombo() }} onSave={onAudienceSave} />}
      {showCreateAdPopup && (
        <BossDialog title={"Create Ad"} width={"65%"} height='82vh' onClose={() => setShowCreateAdPopup(false)}>
          <SMAdEditForm onClose={() => setShowCreateAdPopup(false)} item={dataItem.item} onSaveData={saveDataAdPopup} />
        </BossDialog>
      )}
    </div>
  )
}

export default SMAdsetForm;